/**
 * ContextCallout Component
 *
 * Colored callout box showing Canadian statistic data or contextual tips.
 * Displays a lightbulb icon and informational text in an amber-highlighted box.
 */

import React from "react";
import { Lightbulb } from "lucide-react";
import { cn } from "../utils/cn";

export interface ContextCalloutProps {
  /** Callout text content */
  text: string;
  /** Category identifier for the id attribute */
  category: string;
  /** Optional additional class names */
  className?: string;
}

/**
 * ContextCallout — Statistic/tip callout component
 *
 * Renders an amber-tinted callout with a lightbulb icon and contextual
 * information such as Canadian statistical statistics or helpful tips.
 */
export const ContextCallout: React.FC<ContextCalloutProps> = ({
  text,
  category,
  className,
}) => {
  return (
    <div
      className={cn("onboarding-context-callout", className)}
      id={`context-${category}`}
    >
      <Lightbulb
        size={16}
        className="shrink-0 text-amber-500"
        aria-hidden="true"
      />
      <span>{text}</span>
    </div>
  );
};

export default ContextCallout;
